import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  ReferenceManyField,
  Datagrid,
  EditButton,
} from 'react-admin';

export const VacancyCategoryShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="slug" />
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
      
      <ReferenceManyField
        label="Вакансии в этой категории"
        reference="vacancies"
        target="categoryId"
      >
        <Datagrid>
          <TextField source="title" />
          <TextField source="employment" />
          <BooleanField source="isActive" />
          <DateField source="createdAt" />
          <EditButton />
        </Datagrid>
      </ReferenceManyField>
    </SimpleShowLayout>
  </Show>
);
